import {ENDPOINT_ADMIN_MERCHANT_STATISTIC_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const Emitter = require('mn-utils/Emitter');
const {
  apiRequestAdmin,
} = require('../ws');

const mockMerchantStatistic$ = new Emitter(loopMap(200, (index) => {
  return {
    merchant_id: '' + index + 'c8e846db-71cf-4a87-8f71-1220ac7bc995',
    merchant_name: 'merchant_name',
    turnover: 1,
    eth_count: 1,
    btc_count: 1,
    total_count: 1,
    average_price: '0.01400000000000000000',
    median_price: '0.01400000000000000000',
  };
}));

export function apiAdminMerchantStatisticList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    const items = mockMerchantStatistic$.getValue();
    return CancelablePromise.delay(500, {
      list: items.slice(offset, offset + limit),
      count: items.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_MERCHANT_STATISTIC_LIST, {
    ...params,
    offset,
    limit,
  });
}
